// libs
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
// types
import { Reducers } from 'store/types'
import { IRiskView } from 'types/graphql'
// utils
import orderBy from 'lodash/orderBy'

export interface RiskViewsState {
  data: IRiskView[]
  loading: boolean
}

const initialState: RiskViewsState = {
  data: [],
  loading: false
}

export const riskViewsSlice = createSlice({
  name: Reducers.RISK_VIEWS,
  initialState,
  reducers: (create) => ({
    addRiskView: create.reducer((state, action: PayloadAction<IRiskView>) => {
      state.data = orderBy([...state.data, action.payload], 'name')
    }),
    setRiskViews: create.reducer((state, action: PayloadAction<IRiskView[]>) => {
      state.data = action.payload
    }),
    updateRiskView: create.reducer((state, action: PayloadAction<{ id: string; data: IRiskView }>) => {
      state.data = state.data.map((item) => {
        if (item.id === action.payload.id) {
          return { ...item, ...action.payload.data }
        }
        return item
      })
    }),
    deleteRiskView: create.reducer((state, action: PayloadAction<string>) => {
      state.data = state.data.filter((item) => item.id !== action.payload)
    }),
    setRiskViewsLoading: create.reducer((state, action: PayloadAction<boolean>) => {
      state.loading = action.payload
    })
  }),
  selectors: {
    riskViewsSelector: (state) => state.data,
    riskViewsLoadingSelector: (state) => state.loading
  }
})

export const { addRiskView, setRiskViews, updateRiskView, deleteRiskView, setRiskViewsLoading } = riskViewsSlice.actions

export const { riskViewsSelector, riskViewsLoadingSelector } = riskViewsSlice.selectors
